import { VisitFormData, TaskFormData } from '../../../../interfaces/property-visit.interface';
import { Validation } from '../../../../interfaces/common';
import { APP_ERROR_MESSAGES, VALIDATION_FIELD_MAPPING, PROPERTY_VISIT_STATUS } from '../../../../utils/appConstant';

export const validateVisitForm = (formData: VisitFormData, fieldToValidate?: string): Validation => {
  const validations: Validation = { validate: true, fields: [] };

  const check = (field: string, condition: boolean, message: string) => {
    if (!fieldToValidate || fieldToValidate === field) {
      if (condition) {
        validations.validate = false;
        validations.fields.push({ field, message });
      }
    }
  };

  check(VALIDATION_FIELD_MAPPING.propertyId, !formData.propertyId, APP_ERROR_MESSAGES.propertyVisits.add.blankProperty);
  check(VALIDATION_FIELD_MAPPING.visitDate, !formData.visitDate, APP_ERROR_MESSAGES.propertyVisits.add.blankVisitDate);
  check(VALIDATION_FIELD_MAPPING.visitType, !formData.visitType, APP_ERROR_MESSAGES.propertyVisits.add.blankVisitType);
  check(VALIDATION_FIELD_MAPPING.userRole, !formData.userRole, APP_ERROR_MESSAGES.propertyVisits.add.blankUserRole);
  check(VALIDATION_FIELD_MAPPING.visitedBy, !formData.visitedBy, APP_ERROR_MESSAGES.propertyVisits.add.blankVisitedBy);

  const noteRequiredStatuses = [PROPERTY_VISIT_STATUS.needsClarification, PROPERTY_VISIT_STATUS.notQualified];
  const noteRequired = !!formData.internalStatus && noteRequiredStatuses.includes(formData.internalStatus);
  check(VALIDATION_FIELD_MAPPING.internalNote, noteRequired && !formData.internalNote.trim(), APP_ERROR_MESSAGES.propertyVisits.add.blankInternalNote);

  return validations;
};

export const validateTaskForm = (formData: TaskFormData, fieldToValidate?: string, isEdit = false): Validation => {
  const validations: Validation = { validate: true, fields: [] };

  const check = (field: string, condition: boolean, message: string) => {
    if (!fieldToValidate || fieldToValidate === field) {
      if (condition) {
        validations.validate = false;
        validations.fields.push({ field, message });
      }
    }
  };

  check(VALIDATION_FIELD_MAPPING.taskDescription, !formData.description.trim(), 'Description is required.');
  check(VALIDATION_FIELD_MAPPING.taskCategory, !formData.category, 'Category is required.');
  check(VALIDATION_FIELD_MAPPING.taskPriority, !formData.priority, 'Priority is required.');
  check(VALIDATION_FIELD_MAPPING.taskStatus, !formData.status, 'Status is required.');

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  check(VALIDATION_FIELD_MAPPING.taskDueDate, !formData.due_date, 'Due date is required.');
  if (!isEdit) {
    check(VALIDATION_FIELD_MAPPING.taskDueDate, !!formData.due_date && new Date(formData.due_date) < today, 'Due date cannot be in the past.');
  }

  return validations;
};
